module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARCAYAAAAyhueAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAN5JREFUeNpi/PLlCwMJYAIQXwbiufgUMZFgoBAQBwLxHCBOppah74DYAYifEjKYFENB4D4Q2yIZnEANQ2EGw1w8H5vB5BgKAneA2BmIX2BzMbmGgsBNqItfQw2OhUkwApOUHJAWpcBwLaihzECcCMSLQYZOAzIyGagD/gKxCQuQWAbEFygwiAeIW4CYE4ing8xiJDFHoQOQQbuA2AZqYBalEYXVQEoMBRm4HWrgLGQDyTUUZOBGILaHFizplCZ+mIGuUANTqJFN10ENXIDLQBBgIdHQldCsmYhPEUCAAQCt3DOTbluYoQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/arrow-right.png
// module id = 92
// module chunks = 0